import { useRef, useState, useEffect, useLayoutEffect } from 'react';
import { connect } from 'react-redux';
import { setAlert } from '../actions/defaultActions';

const AlertOverlay = ({ setAlert, message = '' }) => {
  const backdropRef = useRef(null);
  const containerRef = useRef(null);
  const contentRef = useRef(null);
  const [isOverflowing, setIsOverflowing] = useState(false);

  // close the dialog when escape is pressed
  useEffect(() => {
    const onKeyUp = (event) => {
      if(event.key === 'Escape') { setAlert(''); }
    };

    window.addEventListener('keyup', onKeyUp);
    return () => { // remove listener when component unloads
      window.removeEventListener('keyup', onKeyUp);
    };
  }, [setAlert]);

  useEffect(() => {
    if(typeof document.activeElement === 'object') {
      document.activeElement.blur();
    }
  }, []);

  useLayoutEffect(() => {
    if (containerRef.current && contentRef.current) {
      const containerWidth = containerRef.current.offsetWidth;
      const contentWidth = contentRef.current.offsetWidth;
      setIsOverflowing(contentWidth > containerWidth);
    }
  }, [message]);

  return (
    <div 
      ref={backdropRef}  
      className='flex h-screen w-screen fixed bg-[#000000cc] top-0 left-0 justify-center items-center cursor-pointer' 
      onClick={(event) => { if(event.target === backdropRef.current) { setAlert(''); } }}
    >
      <div 
        ref={containerRef}
        className='relative flex flex-col bg-[#555] text-white rounded-lg items-center justify-center w-[400px] max-w-[95%] cursor-default animate-up-fade wrap-anywhere'
      >

        {/* this is a dummy version to test if the content is overflowing horizontally. if it is we start using break-all to force a wrap */}
        <p 
          ref={contentRef}
          className='opacity-0 pointer-events-none absolute px-6 py-8 text-[1.1em] first-letter:capitalize'>
          {message}
        </p>

        {/* Alert Message */}
        <p 
          ref={contentRef}
          className={`${isOverflowing ? 'break-all' : ''} px-6 py-8 text-[1.1em] first-letter:capitalize`}>
          {message}
        </p>

        <div className='h-[1px] w-full bg-[#a59e9e]'></div>

        <button
          className='w-full py-4 text-blue-400 text-[1.2em] font-bold hover:bg-[#666] active:bg-[#777] rounded-b-lg text-center' 
          onClick={() => { setAlert(''); }}
        >
          Ok
        </button>
      </div>
    </div>
  );
};

// define redux state that will be passed in as props
const mapStateToProps = state => { return {}};
export default connect(mapStateToProps, { setAlert })(AlertOverlay);
